import { useSelector } from "react-redux";

import { RootState } from "../../../../redux/store";
import { resolveHeadCountLabel, useActiveProductCategory } from "../../../../util/categoryConfig";
import type { CategoryRoom } from "../../../../api/categoryRooms/categoryRoomsApiSlice";
import type { UseCase } from "../../../../util/useCases";

/**
 * The head-count field's label and upper bound (#3035, M2).
 *
 * The label is the category's word — guests, participants, members — and
 * `guests` wherever nothing is configured, which is today's text. The bound is
 * the picked room's own capacity when the customer came in object-first: the
 * dated search drops a room whose capacity the count exceeds, so offering more
 * would lead straight to "not free then" for the wrong reason. Otherwise it is
 * the caller's existing bound, unchanged.
 */
export const useHeadCount = (
  useCase: UseCase,
  fallbackMax: number,
  pickedRoom: CategoryRoom | null
): { labelKey: string; max: number } => {
  const categoryKey = useActiveProductCategory();
  const label = useSelector((state: RootState) =>
    resolveHeadCountLabel(state.tenantConfig?.config, useCase, categoryKey)
  );
  const capacity = Number(pickedRoom?.accomodationdetail?.guests);
  return {
    labelKey: `book_location.head_count.${label}`,
    max: Number.isInteger(capacity) && capacity > 0 ? capacity : fallbackMax,
  };
};
